var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromptSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2323 2.5H9.16667C6.02397 2.5 4.45262 2.5 3.47631 3.47631C2.5 4.45262 2.5 6.02397 2.5 9.16667V10.8333C2.5 13.976 2.5 15.5474 3.47631 16.5237C4.45262 17.5 6.02397 17.5 9.16667 17.5H10.8333C13.976 17.5 15.5474 17.5 16.5237 16.5237C17.5 15.5474 17.5 13.976 17.5 10.8333V6.76777C17.5 6.38729 17.5 6.19705 17.4798 6.0145C17.4103 5.38608 17.1636 4.79038 16.7683 4.29691C16.6536 4.15356 16.519 4.01904 16.25 3.75C15.981 3.48096 15.8464 3.34644 15.7031 3.23162C15.2096 2.83638 14.6139 2.58964 13.9855 2.52017C13.8029 2.5 13.6128 2.5 13.2323 2.5Z",
    stroke: "#717182",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 2.91797V3.33464C14.1668 4.90599 14.1668 5.69166 13.6787 6.17981C13.1905 6.66797 12.4048 6.66797 10.8335 6.66797H9.16683C7.59548 6.66797 6.8098 6.66797 6.32165 6.17981C5.8335 5.69166 5.8335 4.90599 5.8335 3.33464V2.91797",
    stroke: "#717182",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 17.082V14.1654C14.1668 12.594 14.1668 11.8084 13.6787 11.3202C13.1905 10.832 12.4048 10.832 10.8335 10.832H9.16683C7.59548 10.832 6.8098 10.832 6.32165 11.3202C5.8335 11.8084 5.8335 12.594 5.8335 14.1654V17.082",
    stroke: "#717182",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptSaveIcon);
export default __webpack_public_path__ + "static/media/prompt-save-icon.b78244cf9f7342f9c0a426633ac0ee56.svg";
export { ForwardRef as ReactComponent };